// extracted by mini-css-extract-plugin
export default {"notes":"PodcastNote_notes__CDcIQ","notes-time":"PodcastNote_notes-time__ulr-A","notes-text":"PodcastNote_notes-text__6lGEu"};